import { useTranslation } from 'react-i18next';

interface Feature {
  title: string;
  desc: string;
}

const featureIcons = ['ri-grid-line', 'ri-store-2-line', 'ri-camera-line', 'ri-truck-line'];

export default function InfoSections() {
  const { t } = useTranslation();
  const features = t('home.features.items', { returnObjects: true }) as unknown as Feature[];

  return (
    <section className="w-full bg-background-100">
      <div className="mx-auto max-w-6xl px-4 py-16 md:px-6 md:py-20">
        <div className="grid grid-cols-1 gap-10 lg:grid-cols-2 lg:items-center lg:gap-16">
          <div>
            <span className="text-xs font-semibold uppercase tracking-wider text-accent-600">
              {t('home.intro.eyebrow')}
            </span>
            <h2 className="mt-3 font-heading text-2xl font-semibold leading-snug text-foreground-950 md:text-3xl">
              {t('home.intro.title')}
            </h2>
          </div>
          <div className="space-y-4">
            <p className="text-sm leading-relaxed text-foreground-700 md:text-base">{t('home.intro.p1')}</p>
            <p className="text-sm leading-relaxed text-foreground-700 md:text-base">{t('home.intro.p2')}</p>
          </div>
        </div>

        <div className="mt-16 text-center md:mt-20">
          <h3 className="font-heading text-2xl font-semibold text-foreground-950 md:text-3xl">
            {t('home.features.title')}
          </h3>
          <p className="mx-auto mt-3 max-w-xl text-sm text-foreground-600 md:text-base">
            {t('home.features.subtitle')}
          </p>
        </div>

        <div className="mt-10 grid grid-cols-1 gap-5 sm:grid-cols-2 lg:grid-cols-4">
          {features.map((feature, index) => (
            <div key={feature.title} className="rounded-lg border border-background-200 bg-background-50 p-5">
              <span className="flex h-11 w-11 items-center justify-center rounded-md bg-accent-100">
                <i className={`${featureIcons[index] ?? 'ri-check-line'} text-lg leading-none text-accent-700`}></i>
              </span>
              <h4 className="mt-4 font-heading text-base font-semibold text-foreground-950">{feature.title}</h4>
              <p className="mt-2 text-sm leading-relaxed text-foreground-600">{feature.desc}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}